import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashBurgerMenuComponent } from './smash-burger-menu/smash-burger-menu.component'
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '@app/shared/shared.module';
import { SmashHeaderComponent } from './smash-header/smash-header.component';
import { SmashNavbarMobileComponent } from './smash-navbar-mobile/smash-navbar-mobile.component';
import { SmashBurgerMenuMobileComponent } from './smash-burger-menu-mobile/smash-burger-menu-mobile.component';
import { RouterModule } from '@angular/router';
import { SmashSelectLangModule } from '../smash-select-lang/smash-select-lang.module';
import { SmashFormsModule } from '../smash-forms/smash-forms.module';
import { ModalCookiePreferenceComponent } from './modal-cookie-preference/modal-cookie-preference.component';

@NgModule({
  declarations: [
    SmashBurgerMenuComponent,
    SmashHeaderComponent,
    SmashNavbarMobileComponent,
    SmashBurgerMenuMobileComponent,
    ModalCookiePreferenceComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    TranslateModule,
    SmashFormsModule,
    SmashSelectLangModule,
    SharedModule
  ],
  exports: [
    SmashHeaderComponent,
    SmashNavbarMobileComponent
  ]
})
export class SmashHeaderModule { }
